import { AxiosError } from 'axios'
import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { externalIntegrationsMutationKeys } from 'queries/external-integrations/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'
import { type ObservabilityToolType } from 'types/api/status-checks/status-check'

type DeleteExternalIntegrationsStatusChecksAuthenticationParams = {
  name: string
  domain: string | null
  observabilityToolType?: ObservabilityToolType
  teamId?: string
}

function deleteExternalIntegrationStatusChecksAuthentication(
  mutationKey?: ReturnType<
    typeof externalIntegrationsMutationKeys.deleteStatusCheckAuthentication
  >
) {
  return async () => {
    if (!mutationKey)
      throw new AxiosError(
        'unable to delete integration without required parameters'
      )

    const endpointWithParams = getEndpointWithParams(...mutationKey)

    await agent.delete(endpointWithParams)
  }
}

export function useDeleteExternalIntegrationsStatusChecksAuthentication(
  params:
    | DeleteExternalIntegrationsStatusChecksAuthenticationParams
    | undefined,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) {
  const { currentTeamId } = useAuth()

  const mutationKey = params
    ? externalIntegrationsMutationKeys.deleteStatusCheckAuthentication({
        ...params,
        teamId: params.teamId ?? currentTeamId
      })
    : undefined

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: deleteExternalIntegrationStatusChecksAuthentication(mutationKey)
  })
}
